module.exports = __webpack_public_path__ + "img/LogoNoBrand.234e3be1.svg";